import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/axios';

export interface AssignedMember {
    user_id: string;
    name: string;
    role: string;
}

export interface HierarchyUser {
    user_id: string;
    name: string;
    role: string;
    total_assigned_members: number;
    assigned_members: AssignedMember[];
}

interface UserHierarchyResponse {
    success: boolean;
    message: string;
    data: HierarchyUser[];
}

export function useUserHierarchy() {
    return useQuery<UserHierarchyResponse>({
        queryKey: ['admin', 'user-hierarchy-flat'],
        queryFn: async () => {
            const response = await api.get(`/api/v1/tapanel/user-hierarchy-flat`);
            return response;
        },
        staleTime: 2 * 60 * 1000, // Cache for 2 minutes
    });
}
